<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="375 461.5 50 146"
    height="250"
    width="585"
    version="1.1"
  >
    <g
      transform="matrix(1.3333333,0,0,-1.3333333,0,1122.52)"
      id="g10"
    >
      <g
        transform="scale(0.1)"
        id="g12"
      >
        <path
          id="path14"
          style="fill:#324d89;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="M 4151.3,4947.38 H 1842.45 c -37.8,0 -71.13,-17.25 -90.81,-43.48 -11.81,-15.74 -18.7,-34.72 -18.7,-55.15 V 4435.9 c 365.64,-46.53 768.13,-72.33 1190.89,-72.33 479.87,0 933.62,33.24 1336.98,92.33 v 392.85 c 0,54.47 -49.04,98.63 -109.51,98.63" />
        <path
          id="path16"
          style="fill:#15326a;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="m 1732.94,4435.89 v -458.28 c 0,-54.46 49.03,-98.62 109.51,-98.62 H 4151.3 c 60.47,0 109.51,44.16 109.51,98.62 v 478.28 c -403.36,-59.07 -857.11,-92.32 -1336.98,-92.32 -422.76,0 -825.26,25.8 -1190.89,72.32" />
        <path
          id="path18"
          style="fill:#f7f228;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="m 2246.38,4377.22 h -30.15 v -123.54 h 26.47 c 45.59,0 69.86,21.32 69.86,62.5 0,33.09 -25.74,61.04 -66.18,61.04 m -30.15,93.38 h 22.06 c 30.88,0 53.68,16.18 53.68,50 0,27.22 -22.06,50.74 -52.94,50.74 h -22.8 z m -143.39,-180.16 v 215.46 c 0,50 -0.73,134.56 -2.94,156.62 h 182.36 c 138.98,0 177.95,-68.4 177.95,-124.27 0,-44.85 -22.06,-78.69 -59.56,-97.06 35.29,-15.43 86.77,-53.69 86.77,-123.54 0,-82.34 -62.5,-158.83 -205.16,-158.83 h -183.09 c 2.2,22.79 3.67,81.62 3.67,131.62" />
        <path
          id="path20"
          style="fill:#f7f228;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="m 2749.3,4270.59 c 74.27,0 130.16,62.5 130.16,140.45 0,77.94 -55.89,140.44 -130.16,140.44 -74.27,0 -129.41,-62.5 -129.41,-140.44 0,-77.95 55.14,-140.45 129.41,-140.45 m 0,401.47 c 158.1,0 275.02,-116.91 275.02,-261.02 0,-144.85 -116.92,-261.77 -275.02,-261.77 -157.36,0 -274.27,116.92 -274.27,261.77 0,144.11 116.91,261.02 274.27,261.02" />
        <path
          id="path22"
          style="fill:#f7f228;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="m 3211.78,4435.3 91.91,137.51 c 28.67,44.12 39.71,62.5 53.67,89.71 h 159.57 c -25,-32.36 -37.5,-50 -65.45,-91.18 l -100,-145.59 118.38,-159.57 c 29.42,-38.98 55.87,-69.12 88.25,-107.36 h -194.13 c -8.08,16.18 -22.07,40.44 -46.32,72.8 l -105.88,146.33 v -87.51 c 0,-50 1.45,-108.83 2.93,-131.62 h -150 c 1.46,22.79 2.93,81.62 2.93,131.62 v 240.46 c 0,50 -1.47,109.56 -2.93,131.62 h 150 c -1.48,-22.06 -2.93,-81.62 -2.93,-131.62 v -95.6" />
        <path
          id="path24"
          style="fill:#f7f228;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="m 3736.74,4544.13 v -68.39 h 29.41 c 50,0 104.42,1.48 127.21,2.95 v -124.27 c -22.79,1.47 -77.21,2.93 -127.21,2.93 h -29.41 v -79.41 h 44.86 c 50.74,0 105.88,1.47 127.95,2.95 v -125 c -22.07,1.46 -77.21,2.93 -127.95,2.93 h -191.91 c 1.46,40.45 2.93,98.53 2.93,131.62 v 241.19 c 0,50.73 -1.47,108.83 -2.93,130.89 h 186.03 c 50,0 105.14,2.94 127.93,4.41 v -125.74 c -22.79,2.21 -77.93,2.94 -127.93,2.94 h -38.98" />
        <path
          id="path26"
          style="fill:#706d6e;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="m 3645.82,3721.94 c 0,4.41 -0.8,18 -3.99,22" />
        <path
          id="path28"
          style="fill:#706d6e;fill-opacity:1;fill-rule:nonzero;stroke:none"
          d="m 3736.22,3657.16 c 0,4.8 -3.19,13.2 -8.8,13.2" />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
  export default {
    name: 'BokeLoader'
  };
</script>

<style lang="scss" scoped>
#box-loader {
  animation: 0.8s ease-in-out 0s infinite alternate pulse;

  &.large {
    width: 250px;
    height: 107px;
  }

  &.small {
    width: 25px;
    height: 11px;
    margin-top: -1.55em;
  }
}

@keyframes pulse {
  0% {
    opacity: 1
  }

  100% {
    opacity: 0.7
  }
}
</style>